import { SET_HAPPENING, SET_HAPPENING_NON_CONTENT, SET_FILTERED_EVENTS } from 'constants/actionTypes/happening';
import ContentConstants from 'constants/content';

const { RENDERING_TYPE } = ContentConstants;

const initialState = {};

const reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_HAPPENING: {
            return payload?.data;
        }

        case SET_HAPPENING_NON_CONTENT: {
            return payload?.data;
        }

        case SET_FILTERED_EVENTS: {
            const nextState = { ...state };

            nextState?.layout?.content?.forEach(element => {
                if (element.renderingType === RENDERING_TYPE.HAPPENING_EVENTS_GRID) {
                    element.items = payload?.data?.items;
                    element.refinements = payload?.data?.refinements;
                }
            });

            return nextState;
        }

        default: {
            return state;
        }
    }
};

export default reducer;
